module.exports = __webpack_public_path__ + "image-3ea20fd459f1.png";